export const completeFirstRunStep = (api, step) => {
  api.post('/first-run/complete', { step })
    .then(() => window.dispatchEvent(new CustomEvent('firstrun-updated')))
    .catch(() => {});
};
